module.exports = __webpack_public_path__ + "static/media/soccerball.b5cc6837.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/soccerball.svg
// module id = 137
// module chunks = 0